/* unplugin-vue-components disabled */import script from "./content-wrap.vue?vue&type=script&setup=true&lang=js"
export * from "./content-wrap.vue?vue&type=script&setup=true&lang=js"

import "./content-wrap.vue?vue&type=style&index=0&id=57252f37&lang=scss&scoped=true"

import exportComponent from "D:\\fsplus\\work1\\fsplus-vue-workspace\\foshan-street\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57252f37"]])

export default __exports__